import PropTypes from 'prop-types'
import React, { Component } from 'react'

export default class Loader extends Component {

  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string
  }

  render() {
    return (
      <div
        className={[
          'error',
          this.props.className
        ].join(' ').trim()}
      >
        {this.props.children}
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/shared/components/Error.js